import { createFileRoute } from '@tanstack/react-router';
import { JourneysAudiencesSetupHandoff } from '@/pages/workspaces/integrations/audiences/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

function JourneysAudiencesSetupRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysAudiencesSetupHandoff type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/setup',
)({
  component: JourneysAudiencesSetupRoute,
});
